// Forms validation
const forms = document.querySelectorAll('.needs-validation')

Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
        event.preventDefault()
        if (!form.checkValidity()) {
            event.stopPropagation()
        } else {
            grecaptcha.ready(function () {
                grecaptcha.execute(RECPATCHA_SITE_KEY, {action: 'contact'}).then(function (token) {
                    // Add the token to the form
                    document.querySelector('#g-recaptcha-contact').value = token;

                    var ajaxForm = $(form);
                    $.ajax({
                        url: ajaxForm.attr('action'),
                        method: 'POST',
                        data: ajaxForm.serialize(),
                        dataType: 'json',
                        timeout: 5000
                    }).done(function (data) {
                        ajaxForm.find('.alert').text(data.message);
                        ajaxForm.find('.alert').addClass('alert-' + (data.success ? 'success' : 'warning'));

                        ajaxForm[0].reset();
                    }).fail(function (xhr, status, error) {
                        ajaxForm.find('.alert').text(xhr.responseJSON.errors);
                        ajaxForm.find('.alert').addClass('alert-warning');
                    }).always(function () {
                        $(ajaxForm).find('div[class^="alert-"]').removeClass(function (index, className) {
                            return (className.match(/(^|\s)alert-\S+/g) || []).join(' ');
                        });
                        ajaxForm.find('.alert').removeClass('d-none');
                    })
                });
            });

        }

        form.classList.add('was-validated')
    }, false)
})